/**
* @ngdoc component
* @name help.component:itxHelpSubmenu
* @description
* Submenu index.
* Shows a list of contents with links.
*/
(function() {
    'use strict';

    var itxHelpSubmenu = {
        bindings:{
            submenu: '<'
        },
        controller:   itxHelpSubmenuCtrl,
        templateUrl: 'help-submenu.component.html'
    };

    itxHelpSubmenuCtrl.$inject = [
        'ItxStaticResourceSvc',
        'helpService',
        'DUTTI_CONS'
    ];

    function itxHelpSubmenuCtrl (
        ItxStaticResourceSvc,
        helpService,
        DUTTI_CONS
    ) {
        
        this.$onInit = function () {
            var language = DUTTI_CONS.i_languages[inditex.iLangId].toLowerCase() + '/';
            var region = inditex.iCountryCode.toLowerCase() + '/';
            
            if(region==language){
                language='';
            }
            
            if(this.submenu.name === 'open_stores'){
                location.href = location.origin + '/' + region + language + 'store-locator';
            }
            
            window.scrollTo(0,0);
        };

        this.getIcon = function(iconName){
            return ItxStaticResourceSvc.getIcon(helpService.getIconPath(iconName));
        };
    }

    angular.module('itxApp.help')
           .component('itxHelpSubmenu',itxHelpSubmenu);

})();